module.exports = __webpack_public_path__ + "images/vehicle.d287005d2e5dd431744a4dbd4d8f9b71.png";